import { CasinoGamesAction, CasinoGamesActionsTypes } from './CasinoGamesActions'
import { CasinoGameConfig } from '../../communication/casino-manager/CasinoManagementApi'

export const initialCasinoGamesState: CasinoGameState = {
  casinoGameConfigs: [],
  casinoGameConfigsError: null,
}

export interface CasinoGameState {
  casinoGameConfigs: CasinoGameConfig[];
  casinoGameConfigsError: Error;
}

export const casinoGamesReducer = (
	state: CasinoGameState = initialCasinoGamesState,
	action: CasinoGamesAction,
): CasinoGameState => {
	switch (action.type) {
	case CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_STARTED:
		return { ...state }
	case CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_SUCCESS:
		return { ...state, casinoGameConfigs: action.payload.configs }
	case CasinoGamesActionsTypes.GET_CASINO_GAME_CONFIGS_FAILURE:
		return { ...state, casinoGameConfigsError: action.payload.error }
	default:
		return state
	}
}
